import { FC } from 'react';
import cx from 'clsx';
import styles from './TipOption.module.scss';

export type TipOptionProps = {
  className?: string;
  onClick: () => void;
  isActive: boolean;
};

export const TipOption: FC<TipOptionProps> = props => {
  const { className, onClick, isActive, children, ...buttonProps } = props;

  return (
    <button
      aria-checked={(isActive ? true : false)}
      className={cx(styles.tipButton, className, { [styles.active]: isActive })}
      role="radio"
      type="button"
      onClick={onClick}
      {...buttonProps}
    >
      {children}
    </button>
  );
};
